import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userMenus: [],
    userInfo: {},
    codes: [],
    activeMenuCode: '',
    showTabs: true,
    openMenus: [],
    keepAlive: []
  },
  mutations: {
    setUserMenus: function (state, userMenus) {
      state.userMenus = userMenus
    },
    setUserInfo: function (state, userInfo) {
      state.userInfo = userInfo
    },
    setCodes: function (state, codes) {
      state.codes = codes
    },
    setActiveMenuCode: function (state, activeMenuCode) {
      state.activeMenuCode = activeMenuCode
    },
    addOpenMenus: function (state, addMenu) {
      let isHave = false
      for (let i = 0; i < state.openMenus.length; i++) {
        if (state.openMenus[i].path === addMenu.path) {
          isHave = true
          break
        }
      }
      if (!isHave) {
        state.openMenus.push(addMenu)
        state.keepAlive.push(addMenu.meta.componentName)
      }
    },
    deleteOpenMenus: function (state, deleteOpenMenuCode) {
      let deleteIndex = -1
      for (let i = 0; i < state.openMenus.length; i++) {
        if (state.openMenus[i].path.substring(1) === deleteOpenMenuCode) {
          deleteIndex = i
          break
        }
      }
      if (deleteIndex >= 0) {
        state.openMenus.splice(deleteIndex, 1)
        state.keepAlive.splice(deleteIndex, 1)
      }
    }
  },
  actions: {
    commitUserMenus: function ({ commit }, userMenus) {
      return commit('setUserMenus', userMenus)
    },
    commitUserInfo: function ({ commit }, userInfo) {
      return commit('setUserInfo', userInfo)
    },
    commitCodes: function ({ commit }, codes) {
      return commit('setCodes', codes)
    },
    commitActiveMenuCode: function ({ commit }, activeMenuCode) {
      return commit('setActiveMenuCode', activeMenuCode)
    },
    commitAddOpenMenus: function ({ commit }, addMenu) {
      return commit('addOpenMenus', addMenu)
    },
    commitDeleteOpenMenus: function ({ commit }, deleteOpenMenu) {
      return commit('deleteOpenMenus', deleteOpenMenu)
    }
  },
  modules: {
  }
})
